import React from 'react';
import { Table } from '@tanstack/react-table';

interface PaginationControlsProps {
  table: Table<any>;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({ table }) => {
  const pageCount = table.getPageCount();
  const currentPage = table.getState().pagination.pageIndex;
  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-center gap-3 mt-3 pagination-blk">
      <span className="text-center text-md-start">
        Page {currentPage + 1} of {pageCount}
      </span>

      <div className="pagination-container d-flex align-items-center gap-1" style={{marginLeft:115}}>
        {/* ◀️ Left */}
        <button
        type="button" 
          className="pagination-arrow"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          <i className="ri-arrow-left-circle-line fs-24"></i>
        </button>

        {/* 1 */}
        <button
        type="button" 
          className={`pagination-circle${currentPage === 0 ? ' active' : ''}`}
          onClick={() => table.setPageIndex(0)}
        >
          1
        </button>

        {/* … before */}
        {currentPage > 1 && <span className="pagination-ellipsis">…</span>}

        {/* current */}
        {currentPage > 0 && currentPage < pageCount - 1 && (
          <button
          type="button" 
            className="pagination-circle active"
            onClick={() => table.setPageIndex(currentPage)}
          >
            {currentPage + 1}
          </button>
        )}

        {/* … after */}
        {currentPage < pageCount - 2 && <span className="pagination-ellipsis">…</span>}

        {/* last */}
        {pageCount > 1 && (
          <button
          type="button" 
            className={`pagination-circle${currentPage === pageCount - 1 ? ' active' : ''}`}
            onClick={() => table.setPageIndex(pageCount - 1)}
          >
            {pageCount}
          </button>
        )}

        {/* ▶️ Right */}
        <button
        type="button" 
          className="pagination-arrow"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          <i className="ri-arrow-right-circle-line fs-24"></i>
        </button>
      </div>

      <div className="d-flex align-items-center gap-2 flex-wrap justify-content-center justify-content-md-start">
        <label htmlFor="pageSizeSelect" className="mb-0">Rows per page:</label>
        <select
          id="pageSizeSelect"
          className="form-select"
          style={{ minWidth: "80px" }}
          value={table.getState().pagination.pageSize}
          onChange={(e) => {
            table.setPageSize(Number(e.target.value));
            table.setPageIndex(0);
          }}
        >
          {[5, 10, 20, 50, 100].map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default PaginationControls;




// export const PaginationControlsView: React.FC<{ table: Table<any>, tableName?: string }> = ({ table, tableName }) => {
//   const pageCount = table.getPageCount();
//   const pageIndex = table.getState().pagination.pageIndex ?? 0;

//   return (
//     <div className="brokerage-ui">
//       <style>{`
//         .brokerage-ui { --pg-size:28px; --pg-radius:8px; --pg-border:#e6ebf2; --pg-blue:#2563eb; --pg-text:#0f172a; --pg-icon:#475569; --pg-icon-disabled:#cbd5e1; }
//         .brokerage-ui .panel-pager{padding:10px 14px;background:#fff;gap:10px;flex-wrap:wrap}
//         .brokerage-ui .panel-pager > span{color:#334155;font-size:12.5px;flex:1 1 auto;min-width:180px}
//         .brokerage-ui .pageSizeSelect1{height:var(--pg-size);padding:2px 26px 2px 10px;border:1px solid var(--pg-border);border-radius:var(--pg-radius);background:#fff;box-shadow:none;font-size:12px;line-height:1;width:auto;min-width:88px}
//         .brokerage-ui .pager-controls{display:inline-flex;align-items:center;gap:6px}
//         .brokerage-ui .pager-chevron{width:var(--pg-size);height:var(--pg-size);border-radius:var(--pg-radius);border:1px solid var(--pg-border);background:#fff;display:inline-flex;align-items:center;justify-content:center;padding:0;line-height:1}
//         .brokerage-ui .pager-chevron i{font-size:14px;color:var(--pg-icon)}
//         .brokerage-ui .pager-chevron:disabled i{color:var(--pg-icon-disabled)}
//         .brokerage-ui .pager-chip{min-width:var(--pg-size);height:var(--pg-size);padding:0 8px;border-radius:var(--pg-radius);border:0;background:#fff;color:var(--pg-text);font-weight:600;font-size:12px;display:inline-flex;align-items:center;justify-content:center;line-height:1}
//         .brokerage-ui .pager-chip.active{background:var(--pg-blue);color:#fff}
//       `}</style>

//       <div className="panel-pager border-top px-4 py-3 d-flex align-items-center justify-content-between">
//         <span>
//           {tableName ? `${tableName}: ` : ""}Page {Math.min(pageIndex + 1, pageCount || 1)} of {pageCount || 1}
//         </span>

//         <div className="d-flex align-items-center gap-3">
//           <div className="d-flex align-items-center gap-2">
//             <span>Rows per page:</span>
//             <select
//               className="form-select pageSizeSelect1"
//               value={table.getState().pagination.pageSize}
//               onChange={(e) => { table.setPageSize(Number(e.target.value)); table.setPageIndex(0); }}
//             >
//               {[5, 10, 20, 50, 100].map((s) => <option key={s} value={s}>{s}</option>)}
//             </select>
//           </div>

//           <div className="pager-controls">
//             <button
// type="button"  className="pager-chevron" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
//               <i className="bi bi-chevron-left" />
//             </button>

//             <button
// type="button"  className="pager-chip active">{pageIndex + 1}</button>

//             <button
// type="button"  className="pager-chevron" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
//               <i className="bi bi-chevron-right" />
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
